"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_NAME_MAP = void 0;
/** 事件配置 */
exports.EVENT_NAME_MAP = {
    /** 加载数据为空 */
    dataEmpty: 'dataEmpty'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVnby5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZlZ28udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsV0FBVztBQUNFLFFBQUEsY0FBYyxHQUFHO0lBQzFCLGFBQWE7SUFDYixTQUFTLEVBQUUsV0FBVztDQUN6QixDQUFDIn0=